
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { NotificationItemProps } from ".";
import { loading, index, options } from "store/notification";

interface ApiNotificationInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
    showHome?: boolean;
}

type ApiNotificationOutputProps = OutputBaseProps<{ list: NotificationItemProps[]; pagination?: PaginationProps; }>

export const apiNotificationIndex = async (data: ApiNotificationInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiNotificationOutputProps>("/api/notifications", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiNotificationOptions = async (data: { q?: string; showHome?: boolean; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiNotificationOutputProps>("/api/notifications", { params: { ...data, fields: "id,title,content,showHome,isKhan" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};